import { AUTH_CALLBACK_PATH, AUTH_LOGIN_PATH } from '@frontend/auth';
import { createBrowserRouter } from 'react-router';

import { CallbackPage } from './callback';
import { ErrorBoundary } from './error-boundary';
import { HomePage } from './home';
import { LoginPage } from './login';
import { NotFound } from './not-found';
import { RequireAuthentication } from './require-authentication';
import { RootLayout } from './root';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      { path: AUTH_LOGIN_PATH.slice(1), element: <LoginPage /> },
      { path: AUTH_CALLBACK_PATH.slice(1), element: <CallbackPage /> },
      {
        element: <RequireAuthentication />,
        children: [{ index: true, element: <HomePage /> }],
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
